import React from "react";
import HotTable from "react-handsontable";
import axios from "axios";

class LocationImporter extends React.Component {
  state = {
    locations: [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ],
    states: [
      "AL",
      "Alabama",
      "AK",
      "Alaska",
      "AS",
      "American Samoa",
      "AZ",
      "Arizona",
      "AR",
      "Arkansas",
      "CA",
      "California",
      "CO",
      "Colorado",
      "CT",
      "Connecticut",
      "DE",
      "Delaware",
      "DC",
      "District Of Columbia",
      "FM",
      "Federated States Of Micronesia",
      "FL",
      "Florida",
      "GA",
      "Georgia",
      "GU",
      "Guam",
      "HI",
      "Hawaii",
      "ID",
      "Idaho",
      "IL",
      "Illinois",
      "IN",
      "Indiana",
      "IA",
      "Iowa",
      "KS",
      "Kansas",
      "KY",
      "Kentucky",
      "LA",
      "Louisiana",
      "ME",
      "Maine",
      "MH",
      "Marshall Islands",
      "MD",
      "Maryland",
      "MA",
      "Massachusetts",
      "MI",
      "Michigan",
      "MN",
      "Minnesota",
      "MS",
      "Mississippi",
      "MO",
      "Missouri",
      "MT",
      "Montana",
      "NE",
      "Nebraska",
      "NV",
      "Nevada",
      "NH",
      "New Hampshire",
      "NJ",
      "New Jersey",
      "NM",
      "New Mexico",
      "NY",
      "New York",
      "NC",
      "North Carolina",
      "ND",
      "North Dakota",
      "MP",
      "Northern Mariana Islands",
      "OH",
      "Ohio",
      "OK",
      "Oklahoma",
      "OR",
      "Oregon",
      "PW",
      "Palau",
      "PA",
      "Pennsylvania",
      "PR",
      "Puerto Rico",
      "RI",
      "Rhode Island",
      "SC",
      "South Carolina",
      "SD",
      "South Dakota",
      "TN",
      "Tennessee",
      "TX",
      "Texas",
      "UT",
      "Utah",
      "VT",
      "Vermont",
      "VI",
      "Virgin Islands",
      "VA",
      "Virginia",
      "WA",
      "Washington",
      "WV",
      "West Virginia",
      "WI",
      "Wisconsin",
      "WY",
      "Wyoming"
    ],
    colHeaders: [
      "Name *",
      "Address Line 1",
      "Address Line 2",
      "City",
      "State",
      "Zip Code",
      "Phone Number One",
      "Phone Number One Name",
      "Phone Number Two",
      "Phone Number Two Name",
      "Lesson Requests Offered",
      "Notes"
    ]
  };

  importLocations = () => {
    let that = this;

    axios
      .post("/locations_import", {
        locations: that.state.locations
      })
      .then(function(response) {
        toastr.success(
          "Locations have been imported, please check your email for confirmation"
        );
      })
      .catch(function(error) {
        toastr.error("Locations not imported, check your email for errors");
        console.log(error);
      });
  };

  addRows = () => {
    let rows = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    let locations = this.state.locations;

    this.setState({ locations: locations.concat(rows) });
    toastr.success("Rows added");
  };

  reset = () => {
    let locations = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    this.setState({ locations: locations });
    toastr.success("Grid has been cleared");
  };

  render() {
    let that = this;
    const width = { width: "1100px" };

    let columns = [
      {
        data: "name",
        type: "text"
      },
      {
        data: "addressLineOne",
        type: "text"
      },
      {
        data: "addressLineTwo",
        type: "text"
      },
      {
        data: "city",
        type: "text"
      },
      {
        data: "state",
        type: "autocomplete",
        source: this.state.states,
        strict: false
      },
      {
        data: "zipCode",
        type: "text"
      },
      {
        data: "phoneNumberOne",
        type: "text"
      },
      {
        data: "phoneNumberOneName",
        type: "text"
      },
      {
        data: "phoneNumberTwo",
        type: "text"
      },
      {
        data: "phoneNumberTwoName",
        type: "text"
      },
      {
        data: "privateLessonsOffered",
        type: "autocomplete",
        source: ["Yes", "No"],
        strict: true
      },
      {
        data: "notes",
        type: "text"
      }
    ];

    return (
      <div>
        <h1>Locations Importer</h1>
        <p style={width}>
          Copy and paste your location data from Excel to add them into
          DigiQuatics. Don't have an Excel file already? Download our template
          <a
            className="styled-link"
            href="/download_excel_template.xlsx?template=locations_importer"
          >
            {" "}
            here{" "}
          </a>
          to get started.
        </p>
        <br />
        <a
          className="btn btn-pink btn-raised btn-long margin-right-five"
          onClick={() => that.importLocations()}
        >
          IMPORT
        </a>
        <a
          className="btn btn-indigo btn-raised btn-long margin-right-five"
          onClick={() => that.addRows()}
        >
          ADD ROWS
        </a>
        <a
          className="btn btn-grey btn-raised btn-long"
          onClick={() => that.reset()}
        >
          RESET
        </a>
        <br />
        <br />
        <HotTable
          root="hot"
          data={this.state.locations}
          rowHeaders={false}
          colWidths={[
            200,
            150,
            150,
            150,
            150,
            150,
            150,
            150,
            150,
            100,
            100,
            100,
            400
          ]}
          width={1200}
          height={500}
          colHeaders={this.state.colHeaders}
          columns={columns}
        />
      </div>
    );
  }
}

export default LocationImporter;
